import type { FunctionComponent } from 'react'
import React from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

import type { ReviewsAdviceSingleArticleData } from '../../ReviewsAdviceSinglePage'

export const IntroParagraph: FunctionComponent<Props> = ({ text }) => {
  if (!text) {
    return null
  }

  return (
    <Typography
      className="mb-4 mt-3-md mb-5-md"
      data-testid="typography-intro-paragraph"
      textStyle="sb-text-heading-standfirst"
    >
      {text}
    </Typography>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  text?: ReviewsAdviceSingleArticleData['introParagraph']
}
